/**
 * This hook is used to log messages to the console in QA for debugging purposes.
 * To turn off logging, set the localStorage flag `SSB_SHOW_LOGS` to `false`:
 * To easily find logs, search for `###` in the console.
 *
 * ```
 * localStorage.setItem('SSB_SHOW_LOGS', false);
 * ```
 */
import enviro from 'enviro';
export const useLogger = () => {
  const logInfo = (logId, ...message) => {
    try {
      const showLogs = localStorage.getItem('SSB_SHOW_LOGS');
      if (enviro.isProd() || showLogs === 'false') return;
      console.log('### [%c%s%c]', 'color: #ff8f59', logId, '', ...message);
    } catch (error) {
      return;
    }
  };
  return {
    logInfo
  };
};